import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pending } from 'redux-saga-thunk';
import { compose } from 'redux';
import { notification } from 'antd';
import get from 'lodash/get';
import { formValueSelector } from 'redux-form';
import { isOpen } from '../store/modal/selectors';
import { fromEntities, fromResource } from '../store/selectors';
import { modalHide } from '../store/modal/actions';
import BigQueryModal from '../components/molecules/BigQueryModal/index';
import { authLogout } from '../store/auth/actions';
import { resourceCreateRequest, resourceDeleteSuccess } from '../store/resource/actions';

class BigQueryContainer extends Component {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    runAudienceQuery: PropTypes.func.isRequired,
  };

  onHideBigQuery = () =>
    this.handleRunTest().then(() => {
      this.props.hideModal();
    });

  handleRunTest = () => {
    const { query, deviceGroupName, advertiserId } = this.props;

    // Clear history of UUIDs / Scans before running a new one
    this.props.clearCreativeEntities();

    return this.props
      .runAudienceQuery({
        query,
        options: {
          dryRun: true,
          useStandardSql: get(this.props, 'useStandardSql', false),
        },
        metadata: {
          advertiserId,
          segment: deviceGroupName,
          daidColumn: 'devices',
        },
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not run query.',
          duration: 0,
        })
      );
  };

  render() {
    return (
      <BigQueryModal
        onHideBigQuery={this.onHideBigQuery}
        handleRunTest={this.handleRunTest}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  const deviceCount =
    fromEntities.getDetail(
      state,
      'theTradeDeskQuery',
      fromResource.getList(state, 'theTradeDeskQuery')
    ).deviceCount || 0;

  return {
    visible: isOpen(state.modal, 'create-big-query'),
    loadingAudienceQuery: pending(state, 'theTradeDeskQueryCreate'),
    advertiserId: formValueSelector('Audiences')(state, 'advertiserId'),
    deviceGroupName: formValueSelector('Audiences')(state, 'deviceGroupName'),
    query: formValueSelector('Audiences')(state, 'query'),
    useStandardSql: formValueSelector('Audiences')(state, 'useStandardSql'),
    deviceCount,
  };
};

const mapDispatchToProps = dispatch => ({
  clearCreativeEntities: () => dispatch(resourceDeleteSuccess('the-trade-desk/query', {})),
  runAudienceQuery: data => dispatch(resourceCreateRequest('the-trade-desk/query', {}, data)),
  hideModal: () => dispatch(modalHide('create-big-query')),
  logout: () => dispatch(authLogout()),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BigQueryContainer);
